// #TODO 30-04-2018_FG Terminer les interfaces

// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable ,  BehaviorSubject } from 'rxjs';

@Injectable()
export class BreadcrumbService {
    private static breadcrumb: BehaviorSubject<any> = new BehaviorSubject([]);

    public setItems (newItems): void {
        const currentItems: any = BreadcrumbService.breadcrumb.getValue();
        let items;

        if (currentItems.length > 0) {
            items = currentItems.map((item) => {
                return {
                    ...item,
                    ...newItems[item.code]
                };
            });
        } else {
            items = newItems;
        }

        BreadcrumbService.breadcrumb.next(items.sort(this.compare));
    }

    public getCurrentItems (): any {
        return BreadcrumbService.breadcrumb.getValue();
    }

    public getItems (): Observable<any> {
        return BreadcrumbService.breadcrumb.asObservable();
    }

    private compare (a, b): any {
        let sort;

        if (a.id > b.id) {
            sort = 1;
        } else if (a.id < b.id) {
            sort = -1;
        }

        return sort;
    }
}
